import React from 'react';
import { Nav, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import { useTenant } from '../contexts/TenantContext';
import './Sidebar.css';

const Sidebar = () => {
  const { user, logout } = useAuth();
  const { selectedTenant, clearTenant } = useTenant();

  const handleLogout = () => {
    logout();
  };

  const handleChangeTenant = () => {
    clearTenant();
  };

  return (
    <div className="sidebar">
      <div className="d-flex align-items-center mb-4 p-3">
        <i className="bi bi-cloud-upload fs-3 me-2"></i>
        <h5 className="mb-0 text-white">LMS Migration</h5>
      </div>
      
      <Nav className="flex-column px-3">
        <LinkContainer to="/">
          <Nav.Link className="text-white-50">
            <i className="bi bi-speedometer2 me-2"></i> Dashboard
          </Nav.Link>
        </LinkContainer>
        <LinkContainer to="/users">
          <Nav.Link className="text-white-50">
            <i className="bi bi-people me-2"></i> Usuarios
          </Nav.Link>
        </LinkContainer>
        <LinkContainer to="/categories">
          <Nav.Link className="text-white-50">
            <i className="bi bi-diagram-3 me-2"></i> Categorías
          </Nav.Link>
        </LinkContainer>
        <LinkContainer to="/courses">
          <Nav.Link className="text-white-50">
            <i className="bi bi-book me-2"></i> Cursos
          </Nav.Link>
        </LinkContainer>
        <LinkContainer to="/evaluations">
          <Nav.Link className="text-white-50">
            <i className="bi bi-clipboard-check me-2"></i> Evaluaciones
          </Nav.Link>
        </LinkContainer>
        <LinkContainer to="/enrollments">
          <Nav.Link className="text-white-50">
            <i className="bi bi-person-plus me-2"></i> Matriculación
          </Nav.Link>
        </LinkContainer>
        <LinkContainer to="/notifications">
          <Nav.Link className="text-white-50">
            <i className="bi bi-bell me-2"></i> Notificaciones
          </Nav.Link>
        </LinkContainer>
        <LinkContainer to="/emails">
          <Nav.Link className="text-white-50">
            <i className="bi bi-envelope-paper me-2"></i> Correos
          </Nav.Link>
        </LinkContainer>
        <LinkContainer to="/monitoring">
          <Nav.Link className="text-white-50">
            <i className="bi bi-graph-up me-2"></i> Monitoreo
          </Nav.Link>
        </LinkContainer>
        <LinkContainer to="/apps">
          <Nav.Link className="text-white-50">
            <i className="bi bi-phone me-2"></i> Aplicaciones
          </Nav.Link>
        </LinkContainer>
      </Nav>
      
      <div className="mt-auto p-3">
        <div className="text-center mb-3">
          <div className="badge bg-success mb-2">Sistema Activo</div>
          <div className="small text-white-50 mb-2">
            <i className="bi bi-building me-1"></i>
            {selectedTenant?.name}
          </div>
          <div className="small text-white-50">v2.0.0</div>
        </div>
        <div className="text-center">
          <div className="small text-white-50 mb-2">{user?.username}</div>
          <Button 
            variant="outline-secondary" 
            size="sm" 
            onClick={handleChangeTenant}
            className="w-100 mb-2"
          >
            <i className="bi bi-arrow-left-right me-1"></i>
            Cambiar Institución
          </Button>
          <Button 
            variant="outline-light" 
            size="sm" 
            onClick={handleLogout}
            className="w-100"
          >
            <i className="bi bi-box-arrow-right me-1"></i>
            Cerrar Sesión
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;